import React from "react";
import "./Choose.css";
import { FaTools, FaShieldAlt, FaThumbsUp, FaClock } from "react-icons/fa";

const Choose = () => {
  const features = [
    {
      icon: <FaClock />,
      title: "Quick Response",
      description: "Your satisfaction is our priority. We provide quick responses to inquiries, service requests, and project updates. From the first consultation to project completion, we maintain clear communication and fast support to ensure a smooth experience."
    },
    {
      icon: <FaShieldAlt />,
      title: "Quality Materials",
      description: "We believe long-lasting results start with the finest materials. That’s why we use high-grade aluminium, durable glass, and top-quality accessories for every project. Our commitment to superior materials ensures strength, longevity."
    },
    {
      icon: <FaThumbsUp />,
      title: "Customer Satisfaction",
      description: "Your satisfaction is at the core of everything we do. At Star Aluminium Works, we listen carefully to your requirements and ensure every detail matches your expectations. From the first consultation to the final installation, we work with honesty."
    },
    {
      icon: <FaTools />,
      title: "Trained Workers",
      description: "Our team includes more than ten highly trained and experienced professionals. From aluminium fabrication and glazing to false ceilings and invisible grills, each worker is an expert in their craft. We continuously update our techniques and use modern tools."
    }
  ];

  return (
    <section className="choose-section">
      <div className="choose-container">
        <h2 className="choose-title">Why Choose Us</h2>
        <p className="choose-subtitle">
          Quality, Reliability, and Excellence in every project we handle.
        </p>
        <div className="choose-grid">
          {features.map((feature, index) => (
            <div key={index} className="choose-card">
              <div className="choose-icon">{feature.icon}</div>
              <h3 className="choose-card-title">{feature.title}</h3>
              <p className="choose-card-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Choose;
